import { DateTime } from 'luxon';
import { RecaptchaActions } from '../constants/recaptcha';
import { isPast } from './dates';

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        aludeCookies: any;
    }
}

const NonCriticalRecaptchaActions: RecaptchaActions[] = [
    'ADD_EMAIL_EXTERNAL_ACCESS',
    'BANKING_DEPOSIT',
    'BANKING_EXTERNAL_ACCOUNT_CREATION',
    'CONFIRM_VERIFICATION',
    'CREATE_CONTRACT_PARTY',
    'CREATE_CONTRACT',
    'DELETE_CONTRACT_PARTY',
    'EMAIL_VALIDATION_REQUEST',
    'GET_CONTRACT_EVENTS',
    'PATCH_CONTRACT',
    'POINT_ORDER_REQUEST',
    'PURCHASE_SCREENING',
    'RENTAL_CONTRACT_CREATION',
    'RENTAL_CONTRACT_PATCH',
    'RENTAL_LANDLORD_AUTOFILL',
    'RENTAL_LANDLORD_CREATION',
    'REQUEST_VERIFICATION',
    'SCREENING_REPORT_DOWNLOAD',
    'TOO_GRANT_EXTERNAL_ACCESS',
    'TOO_INSURANCE_QUOTE',
    'VERIFICATION_ISSUING',
    'VERIFY_EMAIL_EXTERNAL_ACCESS',
    'WORKSPACE_INVITE_DELETE_REQUEST',
    'WORKSPACE_INVITE_GET_REQUEST',
];

export const shouldSkipRecaptcha = (action: RecaptchaActions) => {
    if (!NonCriticalRecaptchaActions.includes(action) || !window.aludeCookies) {
        return false;
    }
    const lastRecaptcha = window.aludeCookies.getCookie('lstrcptch');
    if (!lastRecaptcha) {
        return false;
    }
    const expiresAtServer = parseInt(lastRecaptcha.split('|')[0]);
    const timeDiff = parseInt(lastRecaptcha.split('|')[1]);
    const expiresAtClient = DateTime.fromMillis(expiresAtServer - timeDiff);
    // Better safe than sorry. Avoiding failing requests due to differences in
    // timing between server and client
    const expiresAtClientNormalized = expiresAtClient.minus({ minutes: 1 });
    return !isPast(expiresAtClientNormalized);
};
